/* eslint-disable react-hooks/exhaustive-deps */
//import packages
import React from "react";
import { Row, Col, Typography, Collapse } from "antd";
import { dateTimeFormatter } from "../../../utils";

const { Panel } = Collapse;
const { Text } = Typography;

const MIFView = ({ mif = [], mifMetadata = {} }) => {
  if (!mif.length) return 'No QAs Available';

  return (
    <Row>
      <Col span={24}>
        from {mifMetadata.type} {dateTimeFormatter(mifMetadata.createdAt)}
        {mif.map((entry, i) => (
          <Collapse
            key={`${entry.question}-${i}`}
            bordered={false}
            activeKey={mif.map(entry => `${entry.question}-${i}`)}
            expandIconPosition="right"
          >
            <Panel
              key={`${entry.question}-${i}`}
              header={<Text strong>Question {i+1}: {entry.question}</Text>}
            >
              {entry.answers.map((answer, j) => (
                <div key={`${answer.answer}-${j}`}>
                  <Text 
                    strong
                    {
                      ...parseInt(answer.priority) > 1 
                        ? { type: 'danger' }
                        : { className: 'sub-content-color' }
                    }
                  >
                    {answer.answer}
                  </Text>
                </div>
              ))}
            </Panel>
          </Collapse>
        ))}
      </Col>
    </Row>
  );
};

export default MIFView;

